import React, { FC, useState, useEffect, useMemo } from 'react';
import { RouteComponentProps, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { fetchNonProspectSurveyItem } from 'src/app/modules/Survey/network/surveyCrud';
import { NOT_FOUND_ERROR_PAGE_PATH } from 'src/app/common/constants';
import { NonProspectSurveyDetail, SurveyFormMode } from 'src/app/modules/Survey/types/survey-types';
import NonProspectSurveyDetailForm from './components/NonProspectSurveyDetailForm';
import { LayoutSplashScreen } from 'src/app/layout';

const NonProspectSurveyDetailPage: FC<RouteComponentProps> = ({ history, location }) => {
  const { id } = useParams<{ id: string }>();
  const { formMode, code } = useMemo(
    () => ({
      formMode: id ? SurveyFormMode.EDIT : SurveyFormMode.CREATE,
      code: id ? id : undefined,
    }),
    [id],
  );

  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [surveyDetail, setSurveyDetail] = useState<NonProspectSurveyDetail>();

  const reloadData = () => {
    if (code) {
      setIsLoading(true);
      fetchNonProspectSurveyItem(code, dispatch)
        .then((result) => {
          setSurveyDetail(result);
        })
        .catch(() => {
          history.push(NOT_FOUND_ERROR_PAGE_PATH);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    reloadData();
    // eslint-disable-next-line
  }, [code]);

  return (
    <>
      {formMode === SurveyFormMode.CREATE && (
        <>
          <NonProspectSurveyDetailForm formMode={formMode} />
        </>
      )}
      {formMode === SurveyFormMode.EDIT &&
        (isLoading || !surveyDetail ? (
          <LayoutSplashScreen />
        ) : (
          <>
            <NonProspectSurveyDetailForm formMode={formMode} surveyDetail={surveyDetail} />
          </>
        ))}
    </>
  );
};

export default NonProspectSurveyDetailPage;
